<template>

  <modalo
    :title="$t('Import')"
    type="mini"
    @hideModal="hideModal()">

    <form
      :class="{'box-loading': loading}"
      v-on:submit.prevent="importFile">
      <div class="form-group">
        <label>Entidade</label>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="radio-candidate"
            value="candidate"
            v-model="value.entity">
          <label
            class="form-check-label"
            for="radio-candidate">
            Candidate
          </label>
        </div>
      </div>
      <div class="form-group">
        <label>{{ $t('Select the file') }}</label>
        <InputMedia 
          v-model="value.source_media_id" 
          :multiple="true"
          btClass="btn btn-light">
          <i class="fas fa-paperclip" /> {{ $t('Selecionar arquivo CSV') }}
          </InputMedia>
      </div>
      <button
        type="submit"
        class="btn btn-primary">{{ $t('Import') }}</button>
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
import InputMedia from '@/components/Fields/InputMedia'

export default {
  name: 'DataimexModalImport',
  components: {
    InputMedia
  },
  props: [
  ],
  data () {
    return {
      loading: false,
      validateErrors: {},
      value: {
        entity: 'candidate',
        source_media_id: null
      }
    }
  },
  created () {
  },
  methods: {
    hideModal () {
      this.$emit('hideModal')
    },
    importFile () {
      this.loading = true

      this.$store
      .dispatch('importDataimex', this.value)
      .then(() => {
        this.$emit('saved')
      }).catch((err) => {
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dataimex/DataimexModalImport.vue